<mat-expansion-panel
    [expanded]="isExpanded"
    [disabled]="!needsExpansion"
    [hideToggle]="!needsExpansion"
    (opened)="isExpanded = true"
    (closed)="isExpanded = false"
    [ngClass]="{ 'invalid-panel': isInvalid }"
>
    <mat-expansion-panel-header
        [ngStyle]="!needsExpansion ? { cursor: 'default' } : null"
    >
        <mat-panel-description>
            <div class="flex flex-col">
                <mat-radio-button
                    color="primary"
                    [value]="model.value"
                    (change)="onChanged($event.value)"
                    [checked]="isChecked"
                    (click)="$event.stopPropagation()"
                    [disabled]="isDisabled"
                >
                    <span [innerHTML]="getLabelContent()"></span>
                </mat-radio-button>
                <div class="ml-12">
                    <ng-content></ng-content>
                </div>
            </div>
        </mat-panel-description>
    </mat-expansion-panel-header>
</mat-expansion-panel>
